module.exports = __webpack_public_path__ + "img/lacnic.91edf050.svg";